import { Item } from '@react-stately/collections'
import { Selection } from '@react-types/shared'

import { ChipSelect, type ChipSelectProps } from 'components/ChipSelect/ChipSelect'

export function GenericSingleChipPicker<T extends string>({
  onChange,
  selectedValue,
  allValues,
  valueMap,
  ...props
}: {
  onChange: (length: T) => void
  selectedValue: T
  allValues: T[]
  valueMap?: (key: T) => string
} & Partial<ChipSelectProps>) {
  const handleChange = (selection: Selection) => {
    if (!(selection instanceof Set)) return

    const selectedLevel = [...selection][0]
    onChange(selectedLevel as T)
  }

  const selectedKeys = selectedValue ? [selectedValue] : []

  return (
    <ChipSelect
      {...props}
      selectedKeys={selectedKeys}
      selectionMode="single"
      deletable={false}
      onSelectionChange={handleChange}
    >
      {allValues.map((value) => (
        <Item key={value}>{valueMap ? valueMap(value) : value}</Item>
      ))}
    </ChipSelect>
  )
}
